export default "__VITE_ASSET__wNIXqbvv__"